/**
 * created by hezq on 2019-11-20
 *
 * description: 数字工具类
 *
 */

import others from '../other';

/**
 * description: 加法计算
 * @param {Number} arg1 数1
 * @param {Number} arg2 数2
 * @param {Number} arg3 精度
 * @return {Number} 计算结果
 * 
 * created by hezq on 2019-11-20
 *
 */
function accAdd(arg1, arg2, arg3) {
	let r1, r2, m, n;

	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	//动态控制精度长度   
	n = r1 >= r2 ? r1 : r2;
	if (!others.isNull(arg3)) {
		n = arg3;
	}
	n = parseInt(n);
	return ((arg1 * m + arg2 * m) / m).toFixed(n);
};

/**
 * description: 减法计算
 * @param {Number} arg1 数1
 * @param {Number} arg2 数2
 * @param {Number} arg3 精度
 * @return {Number} 计算结果
 * 
 * created by hezq on 2019-11-20
 *
 */
function accSubtr(arg1, arg2, arg3) {
	let r1, r2, m, n;

	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	//动态控制精度长度   
	n = r1 >= r2 ? r1 : r2;
	if (!others.isNull(arg3)) {
		n = arg3;
	}
	n = parseInt(n);
	return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

/**
 * description: 乘法计算
 * @param {Number} arg1 数1
 * @param {Number} arg2 数2
 * @param {Number} arg3 精度
 * @return {Number} 计算结果
 * 
 * created by hezq on 2019-11-20
 *
 */
function accMul(arg1, arg2, arg3) {
	let m = 0,
		s1 = arg1.toString(),
		s2 = arg2.toString();

	try {
		m += s1.split(".")[1].length;
	} catch (e) {
		m = 0;
	}
	try {
		m += s2.split(".")[1].length;
	} catch (e) {
		m = 0;
	}
	if (others.isNull(arg3)) {
		arg3 = 2;
	}
	arg3 = parseInt(arg3);
	return (Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)).toFixed(arg3);
};

/**
 * description: 除法计算
 * @param {Number} arg1 数1
 * @param {Number} arg2 数2
 * @param {Number} arg3 精度
 * @return {Number} 计算结果
 * 
 * created by hezq on 2019-11-20
 *
 */
function accDiv(arg1, arg2, arg3) {
	let t1 = 0,
		t2 = 0,
		r1, r2;

	try {
		t1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		t1 = 0;
	}
	try {
		t2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		t2 = 0;
	}
	if (others.isNull(arg3)) {
		arg3 = 2;
	}
	arg3 = parseInt(arg3);

	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));

	return (r1 / r2 * Math.pow(10, t2 - t1)).toFixed(arg3);
};

let nums = {};

/**
 * description: 加减乘除计算
 * @param {Number} arg1 数1
 * @param {Number} arg2 数2
 * @param {String} opt 运算符
 * @param {Number} arg3 精度
 * @return {Number} 计算结果
 * 
 * created by hezq on 2019-11-20
 *
 */
nums.precise = function(arg1, arg2, opt, arg3) {
	if (opt === "+") {
		return parseFloat(accAdd(arg1, arg2, arg3));
	} else if (opt === "-") {
		return parseFloat(accSubtr(arg1, arg2, arg3));
	} else if (opt === "*") {
		return parseFloat(accMul(arg1, arg2, arg3));
	} else if (opt === "/") {
		return parseFloat(accDiv(arg1, arg2, arg3));
	}
};

/**
 * description: 格式化数字，把数字按3个一组用逗号分开，四舍五入为n位
 * @param {Number} s 需要格式化的数字
 * @param {Number} n 小数的后保留的位数，范围是[0,20]
 * @param {Number} type 格式化数字类型 1-直接舍去，0或不传-四舍五入
 * @return {String} 格式化后的字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
nums.format = function(s, n, type) {
	if (!s) {
		s = 0.00;
	}
	if (n < 0 || n > 20) {
		throw new Error("小数位数范围[0,20]");
	}
	if (type === 1) {
		let p = Math.pow(10, n);

		s = String((Math.round(parseFloat(String(s).replace(/[^\d\.-]/g, "")) * p) / p).toFixed(n));
	} else {
		s = String(parseFloat(String(s).replace(/[^\d\.-]/g, "")).toFixed(n));
	}
	// 取得整数
	let l = s.split(".")[0].split("").reverse();
	// 取得小数点
	let r = s.split(".")[1];
	let t = "";

	for (let i = 0; i < l.length; i++) {
		t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? "," : "");
	}
	if (n === 0) {
		return t.reverse();
	}
	return t.reverse() + "." + r;
};

/**
 * description: 把金额数字转成大写的文字数字
 * @param {Number} s 需要转化的数字
 * @return {String} 中文数字字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
nums.formatToChinese = function(s) {
	//汉字的数字
	let cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
	//基本单位
	let cnIntRadice = new Array('', '拾', '佰', '仟');
	//对应整数部分扩展单位
	let cnIntUnits = new Array('', '万', '亿', '兆');
	//对应小数部分单位
	let cnDecUnits = new Array('角', '分', '毫', '厘');
	//整数金额时后面跟的字符
	let cnInteger = '整';
	//整型完以后的单位
	let cnIntLast = '元';
	//最大处理的数字
	let maxNum = 999999999999999.9999;
	//金额整数部分
	let integerNum;
	//金额小数部分
	let decimalNum;
	//输出的中文金额字符串
	let chineseStr = '';
	//分离金额后用的数组，预定义
	let parts;
	if (money == '') {
		return '';
	}
	money = parseFloat(money);
	if (money >= maxNum) {
		//超出最大处理数字
		return '';
	}
	if (money == 0) {
		chineseStr = cnNums[0] + cnIntLast + cnInteger;
		return chineseStr;
	}
	//转换为字符串
	money = money.toString();
	if (money.indexOf('.') == -1) {
		integerNum = money;
		decimalNum = '';
	} else {
		parts = money.split('.');
		integerNum = parts[0];
		decimalNum = parts[1].substr(0, 4);
	}
	//获取整型部分转换
	if (parseInt(integerNum, 10) > 0) {
		let zeroCount = 0;
		let IntLen = integerNum.length;
		for (let i = 0; i < IntLen; i++) {
			let n = integerNum.substr(i, 1);
			let p = IntLen - i - 1;
			let q = p / 4;
			let m = p % 4;
			if (n == '0') {
				zeroCount++;
			} else {
				if (zeroCount > 0) {
					chineseStr += cnNums[0];
				}
				//归零
				zeroCount = 0;
				chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
			}
			if (m == 0 && zeroCount < 4) {
				chineseStr += cnIntUnits[q];
			}
		}
		chineseStr += cnIntLast;
	}
	//小数部分
	if (decimalNum != '') {
		let decLen = decimalNum.length;
		for (let i = 0; i < decLen; i++) {
			let n = decimalNum.substr(i, 1);
			if (n != '0') {
				chineseStr += cnNums[Number(n)] + cnDecUnits[i];
			}
		}
	}
	if (chineseStr == '') {
		chineseStr += cnNums[0] + cnIntLast + cnInteger;
	} else if (decimalNum == '') {
		chineseStr += cnInteger;
	}
	return chineseStr;
};

/**
 * description: 把字节转化为合适的大单位
 * @param {Number} bytes 字节数
 * @return {String} 格式化后的字符串
 * 
 * created by hezq on 2019-11-20
 *
 */
nums.bytesToSize = function(bytes) {
	if (!bytes || bytes === "" || bytes == null || isNaN(bytes)) {
		return '0 B';
	}

	let k = 1024;
	let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	let i = Math.floor(Math.log(bytes) / Math.log(k));

	return Number((bytes / Math.pow(k, i)).toPrecision(3)) + ' ' + sizes[i];
};

export default nums;



// WEBPACK FOOTER //
// ./src/tools/num/index.js